// extracted by mini-css-extract-plugin
module.exports = {"loginFormWrapper":"reset-password_loginFormWrapper__3lqmd","form":"reset-password_form__1YsMN"};